<ion-header>
  <ion-toolbar class="header-color">
    <ion-buttons *ngIf ="!isIframeLoader" slot="start">
      <ion-back-button defaultHref="search/promotions"></ion-back-button>
    </ion-buttons>
    <ion-title *ngIf="studio.name">{{studio.name | titlecase }}</ion-title>
    <ion-button slot="end" color="light" fill="outline" (click)="presentModal()" ><ion-icon name="funnel-outline"></ion-icon>Filter</ion-button>
  </ion-toolbar>
  <app-promoga-alert></app-promoga-alert>
</ion-header>

<ion-content>
  <div *ngIf="!loadingStudioData">
    <img [src]="studio | getImage:'cover'" class="studio-img">
  </div>
  <ion-grid *ngIf="!loadingStudioData" >
    <ion-row>
      <ion-col>
        <div>
          <h3 class="bold yoga-title">{{studio.name}}</h3>
          <b class="text-light"><span *ngIf="studio['hasOnsiteClass']">{{studio.street_address}}, </span>{{studio.city}} {{studio.province_state}}</b>
          <p class="short-description">{{studio.description}}</p>
          <a (click)="scrollPage('overview')" class="view-more">Show more</a>
          <ion-button expand="block" class="joinBtn bold" (click)="searchPromotions()">Join Now</ion-button>
          <div class="padding-horizontal" *ngIf="studio">
            <span>Share</span>
            <span class="social-icon-btns">
                <a (click)="shareFacebook()" target="_blank">
                    <ion-icon name="logo-facebook" width="37" height="42"></ion-icon>
                </a>
                <a href="{{twitterShareUrl}}" target="_blank">
                    <ion-icon name="logo-twitter" width="37" height="42" ></ion-icon>
                </a>
                <a href="mailto:?subject=Check out this studio on Promoga: {{studio?.title | titlecase}}&body={{emailBody}}" target="_blank">                    
                    <ion-icon name="mail-outline" width="37" height="42" ></ion-icon>
                </a>
            </span>
            <hr />
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="bgGray" *ngIf="!loadingStudioData">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-segment scrollable (ionChange)="segmentChanged($event)" color='secondary'>
            <ion-segment-button value="overview">
              <ion-label>Overview</ion-label>
            </ion-segment-button>
            <ion-segment-button value="schedule">
              <ion-label>Schedule</ion-label>
            </ion-segment-button>
            <ion-segment-button value="location">
              <ion-label>Location</ion-label>
            </ion-segment-button>
            <ion-segment-button value="instructor">
              <ion-label>Instructor</ion-label>
            </ion-segment-button>
            <ion-segment-button value="pricing">
              <ion-label>Term Pricing</ion-label>
            </ion-segment-button>
          </ion-segment>
          
          <h4 class="title" id="schedule">Class Schedule</h4>
          <div class="mb14" *ngFor="let studio of classSchdList">
            <p>{{studio.date | date : 'd EEEE, MMMM y'}}</p>
            <ion-card class="styleCard" *ngFor="let class of studio.classes">
              <ion-card-content>
                <ion-row (click)="searchPromotions2(class)">
                  <ion-col size="6">
                    <div class="ion-text-left">
                      <h4 class="schedule-title">{{class.name}}</h4>
                      <p>{{class.instructor.first_name + " " +class.instructor.last_name}} @{{class.instructor.username}}</p>
                      <p>Class Type: {{class.categoryList.join(", ")}}
                        <svg *ngIf="class.promotion.classes.online_locations.length > 0"
                             (click)="openTooltip($event)" xmlns="http://www.w3.org/2000/svg" style="width: 1rem;"
                             ba
                             class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                clip-rule="evenodd"/>
                        </svg>
                      </p>
                    </div>
                  </ion-col>
                  <ion-col size="6">
                   <div class="ion-text-right"> 
                    <h4 class="schedule-time">{{class.startTime}}
                    <span *ngIf="!class.isOnlineClass" style="color: #888888; font-size: 13px"> {{ timezoneService.getTimezoneCode(venueTimezone) }}</span>
                    <span *ngIf="class.isOnlineClass" style="color: #888888; font-size: 13px"> {{ userTimezone }}</span>
                    </h4>
                    <p>{{class.classDuration}}</p>
                  </div>
                  </ion-col>
                </ion-row>
              </ion-card-content>
            </ion-card>
            <br />
          </div>

          <div class="mb14" id="overview">
            <h4 class="title">Overview</h4>
            <p>{{studio.description}}</p>
          </div>

          <div class="mb14" id="location">
            <h4 class="title">Location</h4>
            <ion-card class="styleCard">
              <div #studioMapContainer id="studioMap"></div>
              <ion-card-header class="locationHeader">
                <ion-card-title class="locationName">Studio Address</ion-card-title>
              </ion-card-header>
              <ion-card-content class="locationContent">
                <span *ngIf="studio['hasOnsiteClass']">{{studio.street_address}}, </span>{{studio.city}} {{studio.province_state}}<span *ngIf="studio['hasOnsiteClass']">, {{studio.postal_zip}}</span>
              </ion-card-content>
            </ion-card>
          </div>

          <div class="mb14" *ngIf="instructorList.length > 0" id="instructor">
            <h4 class="title">Instructors</h4>
            <ion-slides [pager]="instructorList.length > 1">
              <ion-slide *ngFor="let inst of instructorList">
                <ion-card class="instructorCard styleCard" (click)="showInstructor(inst)">
                  <ion-card-content>
                    <div class="alignItems">
                      <ion-avatar class="alignItems">
                        <img [src]="inst | getImage:'profile'">
                      </ion-avatar>
                      <h2 class="bold instructor-name">{{inst.first_name}} {{inst.last_name}}</h2>
                      <p class="bold">@{{inst.username}}</p>
                      <p class="description">{{inst.bio}}</p>
                      <a class="bold">Show more</a>
                    </div>
                  </ion-card-content>
                </ion-card>
              </ion-slide>
            </ion-slides>
          </div>

          <div class="mb14" id="pricing">
            <h4 class="title">Term Pricing</h4>
              <ion-slides [pager]="studio.term_prices.length > 1">
                <ion-slide *ngFor="let plan of studio.term_prices">
                  <ion-card class="termCard">
                    <ion-card-content >
                      <div class="term-plan">
                        <div class="term-name">{{plan.name}}</div>
                        <div class="term-middle"><span class="term-price">${{plan.pivot.price}} </span><span class="term-currency">CAD</span></div>
                        <button type="button" class="btn btn-type2" (click)="buyTermPlan(plan)">Buy</button>
                      </div>
                    </ion-card-content>
                  </ion-card>
                </ion-slide>
              </ion-slides>
              <div *ngIf="studio.term_prices?.length === 0">
                <p>Currently, no term passes offered. Click on the scheduled activities for pricing.</p>
              </div>
          </div>

          <div class="mb14">
            <h4 class="title">Purchase Conditions</h4>
            <p>Reservations required and subject to availability.</p>
            <p>Schedule subject to change or cancellation without notice.</p>
            <p>You must be of the age of majority in your jurisdication to purchase and /or uses a fitness pass.</p>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
